import React from 'react';
import { useConfig } from '../../../context/ConfigContext';

import './Spiner.css';  // Asegúrate de importar el archivo CSS donde definirás los estilos del spinner.

export default function Spiner({ logo }) {
    const { storeSettings } = useConfig();
    
    return (
        <div className='spinnerContainer'>
            <div className='spinner'>
                <img 
                    src={logo} 
                    alt="Spinner" 
                    className={`spinnerImage ${storeSettings.logoType === 'rectangle' ? 'logo-rectangle' : 'logo-circle'}`}
                />
                <p>Cargando...</p>
            </div>
        </div>
    );
}
